module.exports = __webpack_public_path__ + "static/media/Portrait-10265.0c01a055.jpg";